import React, { useState, createContext, useContext } from 'react';
interface ProjectFilterContextType {
  selectedProjects: string[];
  setSelectedProjects: (projects: string[]) => void;
  isProjectSelected: (project: string) => boolean;
  toggleProject: (project: string) => void;
}
const ProjectFilterContext = createContext<ProjectFilterContextType | undefined>(undefined);
export const AVAILABLE_PROJECTS = ['1678 Lexington Ave', '450 Park Avenue South', '520 Fifth Avenue', '88 Greenwich Street', '333 Schermerhorn St', '15 Hudson Yards', '200 Liberty Street', '1 Willoughby Square', 'Court Square LIC', '99 Claremont Ave', '251 Douglass Street', 'Brooklyn Heights Project', 'Queens Plaza Development', 'Bronx Commercial Center', 'Staten Island Warehouse', '100 Wall Street', 'Brooklyn Navy Yard', 'Hudson Yards Tower C', 'Penn Station Renovation'];
export function ProjectFilterProvider({
  children
}: {
  children: ReactNode;
}) {
  const [selectedProjects, setSelectedProjects] = useState<string[]>(AVAILABLE_PROJECTS);
  const isProjectSelected = (project: string) => {
    return selectedProjects.includes(project);
  };
  const toggleProject = (project: string) => {
    setSelectedProjects(prev => {
      if (prev.includes(project)) {
        return prev.filter(p => p !== project);
      } else {
        return [...prev, project];
      }
    });
  };
  return <ProjectFilterContext.Provider value={{
    selectedProjects,
    setSelectedProjects,
    isProjectSelected,
    toggleProject
  }} data-id="element-4096" data-mp="1a7povr2u4r31">
      {children}
    </ProjectFilterContext.Provider>;
}
export function useProjectFilter() {
  const context = useContext(ProjectFilterContext);
  if (context === undefined) {
    throw new Error('useProjectFilter must be used within a ProjectFilterProvider');
  }
  return context;
}